import { render } from "./BadgeAlarmsList.vue?vue&type=template&id=7932faf5"
import script from "./BadgeAlarmsList.vue?vue&type=script&lang=js"
export * from "./BadgeAlarmsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__